import type { DestinationPlatform } from './destinations.interfaces';

/** True when the catalog row is YouTube (video-categories + category picker apply). */
export function isYouTubeCatalogPlatform(platform: Pick<DestinationPlatform, 'name'>): boolean {
  return platform.name?.trim().toLowerCase() === 'youtube';
}

/** True when the catalog row is TikTok (live creator-info + Content Posting UX rules apply). */
export function isTikTokPlatform(platform: Pick<DestinationPlatform, 'name'>): boolean {
  return platform.name?.trim().toLowerCase() === 'tiktok';
}

/** True when the catalog row is Facebook (Page selection + Page settings apply). */
export function isFacebookPlatform(platform: Pick<DestinationPlatform, 'name'>): boolean {
  return platform.name?.trim().toLowerCase() === 'facebook';
}

/** True when the catalog row is Instagram (Reel/Story Content Publishing settings apply). */
export function isInstagramPlatform(platform: Pick<DestinationPlatform, 'name'>): boolean {
  return platform.name?.trim().toLowerCase() === 'instagram';
}
